import React from 'react';
import {withStyles} from 'material-ui/styles';
import classNames from 'classnames';
import {builderStyles} from './style/builder';
import {placeholderDropTarget} from './dsdt/placeholder_drop_target';

class EmptyDropPlaceholder extends React.Component{

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOver && nextProps.isOver) {

        }

        if (this.props.isOver && !nextProps.isOver) {

        }

        if (this.props.isOverCurrent && !nextProps.isOverCurrent) {

        }
    }

    render() {
        const {classes } = this.props;

        const {isOver, canDrop, connectDropTarget } = this.props;

        let dropClass = classNames(
            'drop-target' , {
                [classes.darkGreen] : isOver && canDrop,
                [classes.green] : !isOver && canDrop,
                [classes.red] : isOver && !canDrop
            }
        );

        return connectDropTarget(
            <div className={dropClass}></div>
        );
    }
}

export default withStyles(builderStyles)(
    placeholderDropTarget(EmptyDropPlaceholder)
);


// WEBPACK FOOTER //
// ./src/containers/templates/builder/EmptyDropPlaceholder.jsx